import { Link } from "react-router-dom";
import { DEFAULT_AVATAR } from "../api/client";
import { formatInboxDate } from "../lib/format";

export type InboxRowData = {
  id: string;
  conversation_id: string;
  name: string;
  profile_url?: string | null;
  last_message: string;
  time: string;
};

export type InboxRowProps = {
  row: InboxRowData;
};

/** Single inbox conversation row (avatar + name/date + preview). */
export function InboxRow({ row }: InboxRowProps) {
  const href = `/app/patients/${row.id}/conversations/${row.conversation_id}`;
  const preview =
    row.last_message.length > 100
      ? `${row.last_message.slice(0, 100)}...`
      : row.last_message;

  return (
    <tr>
      <td>
        <Link to={href}>
          <div className="ne__avatar">
            <img src={row.profile_url || DEFAULT_AVATAR} alt="Profile Photo" />
          </div>
        </Link>
      </td>
      <td>
        <Link to={href} className="ne__message__row-link">
          <div className="ne__message__group">
            <span className="ne__message__name-date-group">
              <span className="ne__message__date">{formatInboxDate(row.time)}</span>
              <span className="ne__message__name">{row.name}</span>
            </span>
            <div className="ne__message__message">
              <span>{preview}</span>
            </div>
          </div>
        </Link>
      </td>
    </tr>
  );
}

export type InboxTableProps = {
  rows: InboxRowData[];
};

export function InboxTable({ rows }: InboxTableProps) {
  return (
    <div className="ne__conversations__table">
      <div className="ne__table__padding">
        <table className="ne__table ne__table--avatar">
          <tbody>
            {rows.map((row) => (
              <InboxRow key={row.conversation_id} row={row} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
